import Api from '@/services/Api'
const HEADERURL = 'cat/productos/';
const URL = 'cat/productos/';
const ACCION_AGREGAR_LOTE = 'agregar_producto_lote';
const URL_PRECIOS = 'cat/precios/';
const ACCION_CAMBIAR_ESTATUS_A_PRECIO = 'cambiar_estatus_a_precio';
const ACCION_IMPRIMIR_BARRA = 'imprimir_barra';
const ACCION_IMPRIMIR_HABLADOR = 'imprimir_hablador';

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(sku, params, loading = true) {
        return Api(loading).get(URL + sku, {
            params: params
        })
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    agregar_producto_lote(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_LOTE}/`, params);
    },

    imprimir_barra(sku) {

        return Api().post(`${HEADERURL}${sku}/${ACCION_IMPRIMIR_BARRA}/`);

    },

    imprimir_hablador(sku) {

        return Api().post(`${HEADERURL}${sku}/${ACCION_IMPRIMIR_HABLADOR}/`);

    },

    precios(params) {
        return Api().get(URL_PRECIOS, {
            params: params
        })
    },

    /**
     * Agergar precio al producto
     * @param {
     *       "costo": null,
     *       "valido_desde": null,
     *       "valido_hasta": null,
     *       "tipo_calculo": null,
     *       "margen": null,
     *       "precio": null,
     *       "estatus": false,
     *       "producto": null
     *   } params 
     */
    agregar_precio(params) {
        return Api().post(URL_PRECIOS, params)
    },

    /**
     * Cambia el estatus de un precio
     * @param {*} id 
     * @param {*} params 
     */
    cambiar_estatus_a_precio(id) {
        id = id.replace(/-/g, '');
        return Api().post(`${URL_PRECIOS}${id}/${ACCION_CAMBIAR_ESTATUS_A_PRECIO}/`);
    },

}